import { serviceBillingModel } from '~/models';
import { PreapprovalPeriodType, RecurrencePeriodTypes } from '~/models/service-billing/model';
export const preapprovalPeriodWordMap = {
    [PreapprovalPeriodType.None]: '',
    [PreapprovalPeriodType.NoTimeLimit]: '',
    [PreapprovalPeriodType.Weekly]: 'week',
    [PreapprovalPeriodType.BiWeekly]: 'two weeks',
    [PreapprovalPeriodType.Monthly]: 'month',
    [PreapprovalPeriodType.Quarterly]: 'quarter',
    [PreapprovalPeriodType.Yearly]: 'year'
};
export const recurrencePeriodWordMap = {
    [RecurrencePeriodTypes.Weekly]: 'week',
    [RecurrencePeriodTypes.BiWeekly]: 'two weeks',
    [RecurrencePeriodTypes.Monthly]: 'month',
    [RecurrencePeriodTypes.Quarterly]: 'quarter',
    [RecurrencePeriodTypes.Yearly]: 'year'
};
export function preapprovalPeriodWord(period) {
    return preapprovalPeriodWordMap[period];
}
export function recurrencePeriodWord(period) {
    return recurrencePeriodWordMap[period];
}
export function extendedRecurrencePeriodWord(period) {
    if (period === 'onetime' || period === 'inStages' || period === 'onDemand') return '';
    return recurrencePeriodWordMap[period];
}
export function recurrencePeriodSlashSuffix(period) {
    const word = extendedRecurrencePeriodWord(period);
    return word ? "/".concat(word) : '';
}
const preapprovalPeriodVerbMap = {
    [PreapprovalPeriodType.None]: 'requires',
    [PreapprovalPeriodType.NoTimeLimit]: 'requires',
    [PreapprovalPeriodType.Weekly]: 'requires',
    [PreapprovalPeriodType.BiWeekly]: 'will require',
    [PreapprovalPeriodType.Monthly]: 'requires',
    [PreapprovalPeriodType.Quarterly]: 'requires',
    [PreapprovalPeriodType.Yearly]: 'requires'
};
export function billingPeriodWord(billing) {
    if (serviceBillingModel.isOnDemand(billing)) {
        return preapprovalPeriodWordMap[billing.preapprovalPeriod] || null;
    }
    if (serviceBillingModel.isRecurring(billing)) {
        return recurrencePeriodWordMap[billing.recurrencePeriod] || null;
    }
    return null;
}
export function billingPeriodSlashSuffix(billing) {
    if (!billing) return '';
    const word = billingPeriodWord(billing);
    return word ? "/".concat(word) : '';
}
export function preapprovalPeriodVerb(period) {
    return preapprovalPeriodVerbMap[period];
}
